import React from 'react';
import styled from 'styled-components';
import { Typography, Button, Box } from '@slope/uikit';

export interface ClubCardProps {
  id: string;
  name: string;
  slug: string;
  country: string;
  disabled?: boolean;
  'data-club-slug'?: string;
  onClick?: () => void;
  onButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Card = styled.div.attrs<{ disabled?: boolean; 'data-club-slug'?: string }>((props) => ({
  'data-club-slug': props['data-club-slug'],
}))<{ disabled?: boolean; 'data-club-slug'?: string }>`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  border: 2px solid transparent;
  background: ${(props) => (props.disabled ? '#f8f9fa' : 'white')};
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  min-width: 280px;

  @supports (view-transition-name: none) {
    view-transition-name: ${(props) =>
      props['data-club-slug'] ? `club-card-${props['data-club-slug']}` : 'none'};
  }

  &:hover {
    transform: ${(props) => (props.disabled ? 'none' : 'translateY(-4px)')};
    box-shadow: ${(props) =>
      props.disabled ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 8px 25px rgba(0, 0, 0, 0.15)'};
    border-color: ${(props) => (props.disabled ? 'transparent' : '#007bff')};
  }
`;

export const ClubCard: React.FC<ClubCardProps> = ({
  name,
  slug,
  country,
  disabled = false,
  'data-club-slug': dataSlug,
  onClick,
  onButtonClick,
}) => {
  return (
    <Card data-club-slug={dataSlug || slug} disabled={disabled} onClick={onClick}>
      <Box p="1.5rem">
        <Typography
          fontSize="20px"
          fontWeight="bold"
          mb="0.5rem"
          color={disabled ? '#95a5a6' : '#2c3e50'}
        >
          {name}
        </Typography>
        <Typography fontSize="14px" color={disabled ? '#bdc3c7' : '#7f8c8d'} mb="2rem">
          📍 {country}
        </Typography>
        {disabled && (
          <Typography fontSize="12px" color="#e74c3c" mb="2rem" fontWeight="600">
            Próximamente
          </Typography>
        )}
        <Button
          fullWidth
          disabled={disabled}
          style={{
            backgroundColor: disabled ? '#bdc3c7' : undefined,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1,
          }}
          onClick={onButtonClick}
        >
          {disabled ? 'Próximamente' : 'Explorar Campo'}
        </Button>
      </Box>
    </Card>
  );
};
